/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2026-01-28 15:59:28
 * @LastEditors: 聂章帅
 * @LastEditTime: 2026-03-30 17:23:03
 */
/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2026-01-28 15:59:28
 * @LastEditors: 聂章帅
 * @LastEditTime: 2026-03-30 17:20:14
 */
import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView_三门峡.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      $config.cityName == "三门峡"
        ? import("../views/HomeView_三门峡.vue")
        : import("../views/HomeView.vue")
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/news.vue")
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import("@/views/newsDetail.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
